import { render, staticRenderFns } from "./GetInTouchSection.vue?vue&type=template&id=3980d79d&scoped=true"
import script from "./GetInTouchSection.vue?vue&type=script&lang=js"
export * from "./GetInTouchSection.vue?vue&type=script&lang=js"
import style0 from "./GetInTouchSection.vue?vue&type=style&index=0&id=3980d79d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3980d79d",
  null
  
)

export default component.exports